import type { MutableRefObject } from "react";
import type { AssetLayer } from "../types.ts";

export const createVideoElement = ({
  width,
  height,
  url,
}: {
  width: number;
  height: number;
  url: string;
}) => {
  const videoElt = document.createElement("video");

  videoElt.crossOrigin = "anonymous";
  videoElt.width = width;
  videoElt.height = height;
  videoElt.autoplay = true;
  videoElt.loop = true;
  videoElt.muted = true;

  const sourceElt = document.createElement("source");
  sourceElt.src = url;
  videoElt.appendChild(sourceElt);

  return videoElt;
};

export const buildVideoLayer = ({
  assetLayer,
  videoUrl,
  videoWidth,
  videoHeight,
  targetWidth,
  targetHeight,
  videoRef,
  onLoadedData,
}: {
  assetLayer: AssetLayer;
  videoUrl: string;
  videoWidth: number;
  videoHeight: number;
  targetWidth: number;
  targetHeight: number;
  videoRef?: MutableRefObject<HTMLVideoElement | null>;
  onLoadedData: () => void;
}) => {
  const videoElement = createVideoElement({
    width: videoWidth,
    height: videoHeight,
    url: videoUrl,
  });

  const originalScaleX = assetLayer.scaleX / assetLayer.displayScale;
  const originalScaleY = assetLayer.scaleY / assetLayer.displayScale;

  const newDisplayScaleX = targetWidth / videoWidth;
  const newDisplayScaleY = targetHeight / videoHeight;

  // XXX: This is an arbitrary choice that works well when the asset.content is a children of the overlay, we should use max if we are in the other order.
  const newDisplayScale = Math.min(newDisplayScaleX, newDisplayScaleY);

  videoElement.onloadeddata = () => {
    assetLayer.setElement(videoElement);
    assetLayer.set({
      scaleX: newDisplayScale * originalScaleX,
      scaleY: newDisplayScale * originalScaleY,
      displayScale: newDisplayScale,
    });
    assetLayer.setCoords();
    if (videoRef) videoRef.current = videoElement;
    onLoadedData();
  };
};
